import React, {useState} from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from 'react-bootstrap';
import CookieOptionItem from './CookieOptionItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import styles from '../styles/about/CookieConsent.module.scss';

const CookieOptions = (props) => {

    const {showNotice, saveCookie, defaultPreferences} = props;

    const cookieList = [
        {
            name: 'about',
            title: 'Preferinte cookies',
            description: 
                <>
                    Poți sa îți setezi preferințele cu privire la cookies în secțiunile de mai jos. Mai multe informații despre modul în care utilizăm cookies, poți citi în pagina cu <Link
                    href={`${process.env.NEXT_PUBLIC_WEB}/termeni/cookies`}
                    title="Politica Cookies"
                    target="_blank">politica privind cookies</Link>
                </>,
            selected: true,
            button: 'disabled',
        },
        {
            name: 'essential',
            title: 'Cookies esențiale',
            description: 
                <>
                    Aceste cookies sunt esențiale pentru funcționarea website-ului și nu pot fi dezactivate. Acestea sunt utilizate pentru autentificarea în contul de utilizator și pentru a menține website-ul stabil, sigur și functional.
                </>,
            selected: false,
            button: 'disabled',
        },
        {
            name: 'analytics',
            title: 'Măsurare și analiză',
            description: 
                <>
                    Aceste cookies ne permit să contorizam vizitele și sursele de trafic cu scopul de a măsura și îmbunătăți performanța website-ului. Toate informațiile colectate sunt agregate și, prin urmare, anonime.
                </>,
            selected: false,
            button: defaultPreferences ? (defaultPreferences.analytics == 0 ? 'off' : 'on') : 'off',
        },
        {
            name: 'personal',
            title: 'Personalizare',
            description: 
                <>
                    Aceste cookies ne permit să personalizam experiența de utilizare a website-ului și să salvam preferințele tale pentru o utilizare mai facila a website-ului. În acest mod, vei putea gasi mai rapid informațiile care te intereseaza.
                </>,
            selected: false,
            button: defaultPreferences ? (defaultPreferences.personal == 0 ? 'off' : 'on') : 'off',
        }
    ];

    const [menu, editMenu] = useState(cookieList);

    const viewOption  = (title) => {
        const item = menu.find( item => item.title == title);
        const newList = menu.map( item => {
            if (item.title == title) {
                return {...item, selected: true}
            } else {
                if (item.selected) {
                    return {...item, selected: false};
                }
                return item;
            }
        });
        editMenu(newList);
    }

    const changeSelection  = (title) => {
        const newList = menu.map( item => {
            if (item.title == title) {
                let button = item.button == 'on' ? 'off' : 'on';
                return {...item, button: button}
            } else {
                return item;
            }
        });
        editMenu(newList);
    }

    const listHtml = menu.map( (item, key) => 
        <li key={key}>
            <CookieOptionItem 
                title={item.title} 
                description={item.description}
                selected={item.selected}
                viewOption={viewOption}
                button={item.button}
                changeSelection={changeSelection}
            />
        </li>
    );

    const saveCustomCookie = () => {
        let personal = menu.find(item => item.name=='personal');
        let analytics = menu.find(item => item.name=='analytics');
        let opt = {
            consented: 1,
            categories: {
                analytics: analytics.button == 'on' ? 1 : 0,
                personal: personal.button == 'on' ? 1 : 0,
            },
            consentDate: new Date(),
        }
        saveCookie(opt);
    }

    const saveAllCookie  = () => {
        const opt = {
            consented: 1,
            categories: {
                analytics: 1,
                personal: 1,
            },
            consentDate: new Date(),
        };
        saveCookie(opt);
    }



    return (
        <dialog className={styles.root} >
            <div className={styles.dialogOverlay} ></div>
            <div className={styles.consentPreferences}>
               
                    <div className={`${styles.logo} d-flex justify-content-between`} >
                        <Image src="/images/icons/conso.png" width={70} height={21} alt="Conso" />  
                        <FontAwesomeIcon icon={faTimes} width="16" height="16" className={styles.link} onClick={showNotice}/>
                    </div>
                    
                    <p className="heading3 font-weight-bold">Opțiuni Cookies</p>
                    <div className={styles.preferenceContainer} >
                        <ul className={styles.categoryGroup} role="tablist">
                            {listHtml}
                        </ul>
                        <div className="d-flex justify-content-around pt-3" >
                            <Button variant="secondary" onClick={saveCustomCookie} >
                                Salvează opțiunile
                            </Button>
                            <Button variant="outline-secondary" onClick={saveAllCookie} >
                                Accept toate cookies
                            </Button>
                        </div>
                    </div>
               
            </div>
        </dialog>
    );
}

export default CookieOptions;